import { Tournaments } from '@/routes/Tournaments';

/**
 * Community — i tornei della tua community (fissa la vista `community`).
 *
 * NON e' piu' una casella della griglia della Hub: da li' e' stata sostituita
 * da Missioni, e ora vive come meta' della schermata Amici. Il componente e'
 * rimasto uno solo di proposito — il giorno che questa superficie cresce,
 * cresce in un posto solo. `h-full`: chi lo monta deve dargli un'altezza.
 */
export function CommunityPanel() {
  return (
    <div className="-mx-4 h-full">
      <Tournaments forcedView="community" />
    </div>
  );
}
